import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { UzurvRestConfiguration, UzurvRestService, UZURV_REST_CONFIGURATION } from '@uzurv/http';
import { Deserialize, Serialize } from 'cerialize';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { OffPlatformReservationInfo } from '../../models';

@Injectable({
  providedIn: 'root'
})
export class OffPlatformReservationInfoService extends UzurvRestService {
  readonly resourceUrl = 'offPlatformReservationInfo/';

  constructor(
    httpClient: HttpClient,
    @Inject(UZURV_REST_CONFIGURATION)
    protected uzurvRestConfiguration: UzurvRestConfiguration,
    domSanitizer: DomSanitizer
  ) {
    super(httpClient, uzurvRestConfiguration, domSanitizer);
  }

  /**
   * permission dispatcher_management
   */
  listCompletedRidesWithoutCalculations(pageNumber: number, pageSize: number): Observable<Array<OffPlatformReservationInfo>> {
    return this.get<Array<OffPlatformReservationInfo>>(this.resourceUrl, { pageNumber, pageSize }).pipe(
      map(reservations => Deserialize(reservations, OffPlatformReservationInfo))
    );
  }

  /**
   * permission dispatcher_management
   */
  calculateInput(reservationInfos: Array<OffPlatformReservationInfo>): Observable<Array<OffPlatformReservationInfo>> {
    return this.post<Array<OffPlatformReservationInfo>>(this.resourceUrl, Serialize(reservationInfos, OffPlatformReservationInfo));
  }
}
